module.exports = __webpack_public_path__ + "media/images/vector-2@2x-b51a4ea98c76387005beb28422112cc5.png";